import React from 'react';

interface LearningStreakWidgetProps {
  currentStreak: number;
  longestStreak: number;
  icon: string;
}

export const LearningStreakWidget: React.FC<LearningStreakWidgetProps> = ({ currentStreak, longestStreak, icon }) => {
  return (
    <div className="bg-white flex min-w-60 flex-col overflow-hidden items-stretch justify-center flex-1 shrink basis-[0%] my-auto px-5 py-4 rounded-[10px]">
      {/* Row 1: Icon */}
      <div className="flex w-full items-center">
        <img
          src={icon}
          alt="Streak"
          className="aspect-square object-contain object-center w-8 overflow-hidden shrink-0"
        />
      </div>

      {/* Row 2: Title */}
      <div className="text-[#2D2D2D] text-base font-medium leading-none tracking-[-0.32px] mt-4">
        Learning Streak
      </div>

      {/* Row 3: LeftContent (grey) and RightContent (green) */}
      <div className="flex w-full items-center justify-between mt-3">
        <div className="text-[#928881] text-base font-normal">
          {currentStreak} Day Streak
        </div>
        <div className="text-[#54C082] text-xs font-medium">
          Longest: {longestStreak} Days
        </div>
      </div>
    </div>
  );
};
